import {
    getIsRedirectedToPurchaseBundlePage,
    setIsRedirectedToPurchaseBundlePage,
} from "JS/Helpers/LocalStorageHelpers";
import {
    setLoadingPurchaseBundle,
    setPurchaseBundlePopupState,
    setShowPurchaseBundlePopup,
} from "JS/Redux/PurchaseBundle";
import { useAppDispatch, useAppSelector } from "JS/Redux/Store";
import { useCallback, useEffect } from "react";
import {
    useGlobalMediaEssentials,
    useMediaEssentials,
} from "./MediaEssentials";
import {
    useGlobalPaymentEligibleUsers,
    usePaymentEligibleUsers,
} from "./PaymentEligibleUsers";
import { useTeamInformation } from "./Home";
import { isSubscribed } from "JS/Helpers/HomePageHelper";
import { UserTeamInfo } from "JS/Models";

export const usePurchaseBundlePopup = (skip: boolean = false) => {
    const dispatch = useAppDispatch();
    const userTeamInformation = useAppSelector(
        (state) => state.home.userTeamInformation,
    );
    const { mediaEssentials } = useGlobalMediaEssentials();
    const { paymentEligibleUser } = useGlobalPaymentEligibleUsers();
    const { refetch: fetchTeamInfo } = useTeamInformation(true);
    const { refetch: fetchMediaEssentials } = useMediaEssentials();
    const { refetch: fetchPaymentEligibleUser } = usePaymentEligibleUsers();

    const getPurchaseBundleStatus = useCallback(async () => {
        if (getIsRedirectedToPurchaseBundlePage() === "true") {
            setIsRedirectedToPurchaseBundlePage("false");
            dispatch(
                setPurchaseBundlePopupState({
                    loadingPurchaseBundle: false,
                    showPurchaseBundlePopup: false,
                }),
            );
            return;
        }

        try {
            dispatch(setLoadingPurchaseBundle({ loadingPurchaseBundle: true }));
            const updatedTeamInfo = userTeamInformation?.activeSubscriptions
                ?.length
                ? userTeamInformation
                : ((await fetchTeamInfo()).data as UserTeamInfo);

            const isEligible =
                paymentEligibleUser?.isEligible !== null
                    ? paymentEligibleUser.isEligible
                    : await fetchPaymentEligibleUser();

            const updatedMediaEssentials = mediaEssentials
                ?.user_subscriptions_for_purchase_bundle?.length
                ? mediaEssentials
                : await fetchMediaEssentials();

            const showPopup =
                isEligible &&
                !isSubscribed(
                    updatedMediaEssentials.user_subscriptions_for_purchase_bundle,
                    updatedTeamInfo,
                );
            dispatch(
                setShowPurchaseBundlePopup({
                    showPurchaseBundlePopup: showPopup,
                }),
            );
        } catch (err) {
            console.log("Error in Fetching purchase bundle popup APIs.", err);
        } finally {
            dispatch(
                setLoadingPurchaseBundle({
                    loadingPurchaseBundle: false,
                }),
            );
        }
    }, [
        userTeamInformation,
        paymentEligibleUser,
        mediaEssentials,
        fetchTeamInfo,
        fetchMediaEssentials,
        fetchPaymentEligibleUser,
        dispatch,
    ]);

    useEffect(() => {
        if (!skip) getPurchaseBundleStatus();
    }, [skip, getPurchaseBundleStatus]);

    return {
        getPurchaseBundleStatus,
    };
};
